import dayjs from "dayjs";
import { ObjectGeneric } from "../../../../../utils/types/generals"
import { FrequencyEnum, ScheduleEnumType } from "../../form/components/steps/configCalendar/enums";
import { getDataByFrequency, getDayText, getFrecuencyNameText } from "../../main/methods"
import { Constants } from "../../../../../utils/constants";

export const formatDataToEndoint = ({ data, selected, selectedDays, option }: { data: ObjectGeneric, selectedDays?: number[], selected: { stores: number[]; questionnaire: number[]; }, option: ScheduleEnumType }) => {
    const body: {
        title?: string
        description?: string
        questionnaires: { questionnaireId: number }[]
        userAssignId: number[]
        storeId: number
        originStoreId?: string | null
        openScheduled: boolean
        dateStart?: string
        dateEnd?: string
        timeStart?: string | null
        timeEnd?: string | null
        notified?: number
        notifiedAdmin?: number
        duration?: number | null
        days?: number[] | null
        frequency?: string
        every?: string | null
    }[] = []

    if (option !== ScheduleEnumType.RECURRENT) {
        const { dateEnd, dateStart, /* days, */ duration, every, frequency, timeEnd, timeStart } = getDataByFrequency(data);

        body.push({
            openScheduled: !!data.openQuestionnaire,
            questionnaires: [{ questionnaireId: selected.questionnaire[0] }],
            storeId: selected.stores[0],
            originStoreId: data.originStoreId?.id || null,
            userAssignId: data.user,
            title: data.title ?? '',
            notified: data.notified ? 1 : 0,
            notifiedAdmin: data.notifiedAdmin ? 1 : 0,
            description: data.description ?? '',
            ...!data.openQuestionnaire && {
                dateStart: dateStart,
                dateEnd: dateEnd,
                every: every,
                timeStart: timeStart,
                timeEnd: timeEnd,
                frequency: frequency,
                duration: duration,
                days: selectedDays?.map((num: number) => num === 7 ? 0 : num)
            }
        })
    }

    if (option == ScheduleEnumType.RECURRENT) {
        const frequencyText = getFrecuencyNameText(data.frequency as FrequencyEnum) ;

        body.push({
            openScheduled: !!data.openQuestionnaire,
            questionnaires: [{ questionnaireId: selected.questionnaire[0] }],
            storeId: selected.stores[0],
            userAssignId: data.user,
            title: data.title ?? '',
            description: data.description ?? '',
            notified: data.notified ? 1 : 0,
                notifiedAdmin: data.notifiedAdmin ? 1 : 0,
            ...!data.openQuestionnaire && {
                dateStart: dayjs(data.from).format(Constants.dayjsFormat3),
                dateEnd: dayjs(data.to).format(Constants.dayjsFormat3),
                every: getDayText(data.dayOfWeek),
                timeStart: data.from?.format(Constants.timeFormat),
                timeEnd: data.to?.format(Constants.timeFormat),
                frequency: frequencyText,
                duration: Number(data.duration.match(/\d+/)?.[0]),
                days: selectedDays?.map((num: number) => num === 7 ? 0 : num)
            }
        })
    }


    return body
}
